import { useTranslation } from 'react-i18next'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { Col, Tooltip } from 'antd'

import { useFilters, useGeneral, useUser } from '@contexts'
import { Filters } from '@types'
import { ImplementationTimeUtils } from '@utils'

const { companyStartOfIsoWeek, companyStartOfToday } = ImplementationTimeUtils

const RangeTimeSwitcher = () => {
  const { t } = useTranslation()
  const { filters, setFilters } = useFilters()
  const { state } = useUser()
  const gmtZone = state?.company?.gmtZone ?? 0
  const isSupplier = state?.roles.some(rol => rol.name === 'SUPPLIER')
  const today = companyStartOfToday(gmtZone).format('MMDDYY')
  const weekMonday = companyStartOfIsoWeek(filters?.mondayOfWeek ?? new Date(), gmtZone)
  const limit = weekMonday.format('MMDDYY')
  const { setTicketToSearch, ticketToSearch } = useGeneral()

  const handlePreviewsWeek = () => {
    if (ticketToSearch) setTicketToSearch(undefined)
    setFilters((prevState: Filters) => ({
      ...prevState,
      mondayOfWeek: companyStartOfIsoWeek(weekMonday.subtract(7, 'day'), gmtZone).toDate(),
    }))
  }
  const handleNextWeek = () => {
    if (ticketToSearch) setTicketToSearch(undefined)
    setFilters((prevState: Filters) => ({
      ...prevState,
      mondayOfWeek: companyStartOfIsoWeek(weekMonday.add(7, 'day'), gmtZone).toDate(),
    }))
  }

  return (
    <Col className="week-handler-container">
      {isSupplier && today >= limit && !!(!filters?.evouchers && !filters?.previous) ? (
        <ArrowLeftOutlined className="arrow-disabled" />
      ) : (
        <>
          <Tooltip title={t('range_time_switcher.last_week')}>
            <ArrowLeftOutlined onClick={handlePreviewsWeek} />
          </Tooltip>
        </>
      )}
      <div>{`${weekMonday.format('dd DD-MM-YY')} / ${weekMonday
        .isoWeekday(7)
        .format('dd DD-MM-YY')}`}</div>
      <Tooltip title={t('range_time_switcher.next_week')}>
        <ArrowRightOutlined onClick={handleNextWeek} disabled />
      </Tooltip>
    </Col>
  )
}

export default RangeTimeSwitcher
